import * as debug from 'debug';
import * as _ from 'lodash';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { ModalController, ToastController } from 'ionic-angular';
import { ToolsProvider } from '../../../providers/tools/tools';
import { MessagesProvider } from '../../../providers/messages/messages';
import { CrudApiProvider } from '../../../providers/crud-api/crud-api';
import { UserProvider } from '../../../providers/user/user';
import { LiveChatProvider } from '../../../providers/live-chat/live-chat';
import moment from 'moment';
import { ConfigProvider } from '../../../providers/config/config';
@Component({
  selector: 'chats',
  templateUrl: 'chats.html',
})
export class ChatsComponent implements AfterViewInit {
  log = debug('app:ChatsComponent');

  @ViewChild('chatWindow') private chatWindow: ElementRef;

  @Output() unReadMeassage = new EventEmitter<boolean>();

  subscribe: boolean = false;
  loading = true;
  setExpanded = false;
  expandedRooms = [];
  rooms: any[] = [];
  otherRooms = [];
  subs = [];
  typingUsers = {};
  totalUsersInChat: any;
  allPublicChats: any;
  chatTitle: string = '';
  chatRoomsWithUnReadMessage;

  constructor(
    public tools: ToolsProvider,
    public modalCtrl: ModalController,
    public liveChat: LiveChatProvider,
    public toastCtrl: ToastController,
    public crudApi: CrudApiProvider,
    public user: UserProvider,
    private cdr: ChangeDetectorRef,
    public configs: ConfigProvider
  ) {
    this.log('chats');
  }

  ngOnInit() {
    const messages: boolean = true;
    this.unReadMeassage.emit(messages);

    this.setup();

    const storedChatRoom = localStorage.getItem('recently-updated-chats');
    this.chatRoomsWithUnReadMessage = storedChatRoom
      ? (JSON.parse(storedChatRoom) as string[])
      : [];

    this.liveChat.on('new-live-chat-message', data => {
      let recentChatId = data.data.userId;

      if (this.user.info._id !== recentChatId) {
        const storedChatRoom = localStorage.getItem('recently-updated-chats');
        this.chatRoomsWithUnReadMessage = storedChatRoom
          ? (JSON.parse(storedChatRoom) as string[])
          : [];
      }
    });

    this.tools.on('refresh-live-chat', refresher => {
      this.setup(true, refresher);
    });
  }

  async setup(refresh?, refresher?) {
    this.setExpanded = false;
    // this.rooms = [];
    // this.expandedRooms = [];

    if (!refresh) {
      this.tools.on('viewWillEnter', async data => {
        if (data?.id === 'ChatsHomePage') this.setup(true);
      });
    }
    this.liveChat
      .getPublicRooms()
      .then(publicChats => {
        this.rooms = publicChats;

        _.each(
          _.sortBy(this.rooms, r => _.size(r?._onlineUsers)),
          rm => {
            // _.set(rm, '.created', moment(rm?.dates?.created).fromNow());
            if (
              rm.expandable &&
              !this.setExpanded &&
              _.size(rm.messages) >= 3 &&
              !rm.isClosed
            ) {
              this.setExpanded = true;
              rm.expandChat = true;
            }
            this.typingUsers[rm.socketId] = [];
            if (!refresh) {
              this.setupListeners(rm);
            }
          }
        );
        this.expandedRooms = _.filter(this.rooms, rm => rm.expandChat && !rm.states.isClosed);
        this.otherRooms = _.sortBy(
          _.filter(this.rooms, rm => !rm.expandChat || (rm.expandChat && rm.states.isClosed)),
          'isClosed',
          'desc'
        );

        // this.totalUsersInChat = _.size(this?.expandedRooms[0]?.userIds);

        _.each(this.expandedRooms[0]?._onlineUsers, onlineUser => {
          this.checkIfChatMembersAreFriends(onlineUser);
        });

        this.joinExpandedRooms();
        if (refresher) {
          refresher.complete();
        }
      })
      .catch(e => {});
  }

  async setupListeners(rm) {
    this.subs.push(
      this.liveChat.on('socket--message-create--' + rm.socketId, async data => {
        this.log('socket--message-create--' + rm.socketId, data);
        this.rooms = await this.liveChat.reloadPublicRooms();
      })
    );
    this.subs.push(
      this.liveChat.on('socket--typing-start--' + rm?.socketId, data => {
        this.log('socket--typing-start--' + rm?.socketId, data);
        const newUser = _.get(data, 'user');
        const userId = _.get(newUser, '_id');
        const userExists = this.typingUsers[rm?.socketId].some(
          user => _.get(user, '_id') === userId
        );

        if (!userExists) {
          this.typingUsers[rm?.socketId].push(newUser);
        }
      })
    );
    this.subs.push(
      this.liveChat.on('socket--typing-stop--' + rm?.socketId, data => {
        this.log('socket--typing-stop--' + rm?.socketId, data);
        this.typingUsers[rm?.socketId] = _.uniq(
          _.filter(
            this.typingUsers[rm?.socketId],
            u => u.username !== _.get(data, 'user.username')
          ),
          'username'
        );
      })
    );
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.scrollToBottom();
    // }, 500);
  }

  async checkIfChatMembersAreFriends(onlineUser) {
    let userId = _.get(this.user, 'info._id');

    if (userId === onlineUser?._id) {
      this.removeUserFromArray(onlineUser);
      return;
    }

    if (userId !== onlineUser?._id) {
      try {
        const res = await this.crudApi.get(
          `/api/friends/${userId}/${onlineUser?._id}`
        );

        if (res.data != null) {
          const { userA, userB } = res.data;

          if (
            (userA === onlineUser?._id && res.data.accepted) ||
            (userB === onlineUser?._id && res.data.accepted)
          ) {
            this.moveUserToBeginning(onlineUser);
          } else {
            this.moveUserToEnd(onlineUser);
          }
        } else {
          this.moveUserToEnd(onlineUser);
        }
      } catch (e) {
        this.log('error', e);
      }
    }
  }

  moveUserToBeginning(onlineUser) {
    const index = this.expandedRooms[0]?._onlineUsers.findIndex(
      user => user._id === onlineUser?._id
    );
    if (index !== -1) {
      this.expandedRooms[0]?._onlineUsers.splice(index, 1);
      this.expandedRooms[0]?._onlineUsers.unshift(onlineUser);
    }
  }

  moveUserToEnd(onlineUser) {
    const index = this.expandedRooms[0]?._onlineUsers.findIndex(
      user => user._id === onlineUser?._id
    );
    if (index !== -1) {
      this.expandedRooms[0]?._onlineUsers.splice(index, 1);
      this.expandedRooms[0]?._onlineUsers.push(onlineUser);
    }
  }

  removeUserFromArray(onlineUser) {
    const index = this.expandedRooms[0]?._onlineUsers.findIndex(
      user => user._id === onlineUser?._id
    );
    if (index !== -1) {
      this.expandedRooms[0]._onlineUsers?.splice(index, 1);
    }
  }

  joinExpandedRooms() {
    _.each(this.expandedRooms, rm => {
      this.liveChat.joinRoomSocket(rm.socketId);
    });
  }

  private preventDefaults(event) {
    try {
      event.preventDefault();
      event.stopPropagation();
    } catch (e) {}
  }

  private scrollToBottom(): void {
    if (this.chatWindow) {
      this.chatWindow.nativeElement.scrollTop =
        this.chatWindow.nativeElement.scrollHeight;
    }
  }

  async navToGeneralChat(event, convo, socketId) {
    this.preventDefaults(event);
    this.liveChat
      .getConversation(convo)
      .then(conversation => {
        if (conversation?.isClosed) {
          return this.toastCtrl
            .create({
              message:
                'This room is not currently open. Please try again or come back later.',
              duration: 1000,
            })
            .present();
        } else {
          // TODO navTo
          // this.tools.openExternalUrl(
          //   `/home/chat/${conversation._id}`,
          //   'deep-link'
          // );
          this.tools.navTo('ChatPage', 1, {conversation_id: conversation._id});
        }
      })
      .catch(e => {
        this.log('error getting conversation');
        const toast = this.toastCtrl.create({
          message:
            'An error occurred while retrieving this conversation. Please check your connection and try again. If the issue continues, please contact us for help.',
          position: 'top',
          duration: 5000,
        });
        toast.present();
      });

    const key = 'recently-updated-chats';

    // Retrieve the array from local storage and parse it
    const storedData = localStorage.getItem(key);
    let chatArray: string[] = storedData ? JSON.parse(storedData) : [];

    // Check if the socketId exists in the array and remove it if found
    this.chatRoomsWithUnReadMessage = this.chatRoomsWithUnReadMessage.filter(
      id => id !== socketId
    );
    chatArray = chatArray.filter(id => id !== socketId);

    // Update the local storage with the modified array
    localStorage.setItem(key, JSON.stringify(chatArray));
  }

  requestNewGroup() {
    const userId = this.user.info._id;
    let s = `Send us your best ideas for a new Group Chat: ${userId}`;
    window.open(`mailto:app@cdllife.com?subject=${s || ''}`, '_system');
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/chats/chats.ts